import { createContext } from 'react'
/* TODO: CONNECT TO USER TYPE */
export const UserContext = createContext({
    displayName: null,
    countryCode: 1,
    email: '',
    firstName: '',
    isDriver: false,
    isSBCustomer: false,
    isVendor: false,
    lastName: '',
    phone: '',
    role: '',
    stores: [''],
    driverProfileDetails: '',
    clients: '',
    visibilityThreshold: '',
    regions: [''],
})
